module.exports = __webpack_public_path__ + "static/media/caricatura.b2b6fc5d.jpeg";